import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import isEmpty from 'lodash/isEmpty'

import { fetchPhotos } from '@/api/unsplash'
import { Queries } from '@/constants/queries'

import useOnQueryResult from './useOnQueryResult'
import { useAppContext } from '../context/AppContext'
import { getAPIErrorMessage } from '../helpers/apiErrorHelper'

const useUnsplash = () => {
  const [unsplashQuery, setUnsplashQuery] = useState({})
  const [defaultCoverImages, setDefaultCoverImages] = useState({})
  const { addEvent } = useAppContext()

  useOnQueryResult([Queries.UNSPLASH_IMAGES, unsplashQuery], {
    onSuccess: (data) => {
      const getFirstImage = (data) => {
        if(isEmpty(data)) {
          return {
            id: null,
            url: null
          }
        }
        return {
          id: data[0].id,
          url: data[0].urls.regular
        }
      }
      if(!unsplashQuery.orientation) {
        setDefaultCoverImages({
          landscape: getFirstImage(data.landscape),
          portrait: getFirstImage(data.portrait),
        })
      }
    },
    onError: (err) => {
      console.error(err)
      addEvent({
          message: getAPIErrorMessage(err, 'unsplash service'),
          type: 'error'
      })
    }
  })

  const templateImagesReq = useQuery({
    queryKey: [Queries.UNSPLASH_IMAGES, unsplashQuery],
    queryFn: () => fetchPhotos(unsplashQuery),
    enabled: !isEmpty(unsplashQuery),
    onError: (err) => {
      console.error(err)
      addEvent({
          message: getAPIErrorMessage(err, 'templateImagesReq'),
          type: 'error'
      })
    }
  })

  return {
    templateImagesIsLoading: templateImagesReq.isLoading,
    templateImagesIsError: templateImagesReq.isError,
    templateImagesData: templateImagesReq.data,
    setUnsplashQuery,
    fetchTemplateImagesData: templateImagesReq.refetch,
    defaultCoverImages,
    unsplashQuery,
    setDefaultCoverImages
  }
}

export default useUnsplash
